import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';

import {
  FETCH_APIKEY_REQUEST,
  FETCH_APIKEY_SUCCESS,
  FETCH_APIKEY_FAILURE,
  CREATE_APIKEY_REQUEST,
  CREATE_APIKEY_SUCCESS,
  CREATE_APIKEY_FAILURE,
  DELETE_APIKEY_REQUEST,
  DELETE_APIKEY_SUCCESS,
  DELETE_APIKEY_FAILURE,
} from '../actions/apikeyAction';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = `${getBaseUrl()}/api/api-keys`;
const getAuthToken = () => localStorage.getItem('authToken');

function* fetchApikeySaga(action) {
  try {
    const token = getAuthToken();
    const response = yield call(axios.get, API_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put({ type: FETCH_APIKEY_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: FETCH_APIKEY_FAILURE, payload: error.message });
  }
}

function* createApikeySaga(action) {
  try {
    const token = getAuthToken();
    const response = yield call(axios.post, API_BASE_URL, action.payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put({ type: CREATE_APIKEY_SUCCESS, payload: response.data });
    if (action.callback) {
      action.callback(response.data);
    }
  } catch (error) {
    yield put({ type: CREATE_APIKEY_FAILURE, payload: error.message });
  }
}

function* deleteApikeySaga(action) {
  try {
    const token = getAuthToken();
    const response = yield call(axios.delete, `${API_BASE_URL}/${action.payload}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put({ type: DELETE_APIKEY_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: DELETE_APIKEY_FAILURE, payload: error.message });
  }
}

export default function* apikeySaga() {
  yield takeLatest(FETCH_APIKEY_REQUEST, fetchApikeySaga);
  yield takeLatest(CREATE_APIKEY_REQUEST, createApikeySaga);
  yield takeLatest(DELETE_APIKEY_REQUEST, deleteApikeySaga);
}
